// The bootcamp form calls the seat limit "Capacity"; the Bootcamp model stores it as
// `maxStudents`. Sending `capacity` made the server silently drop it (unknown field).
export function capacityToMaxStudents(capacity) {
  if (capacity === null || capacity === undefined || String(capacity).trim() === "") return null;
  return Number(capacity);
}

// Body for POST/PUT /bootcamps: the form state with list fields cleaned and Capacity mapped.
export function buildBootcampPayload(formData) {
  const { capacity, ...rest } = formData;
  const clean = (items) => items.map((item) => item.trim()).filter((item) => item !== "");
  return {
    ...rest,
    maxStudents: capacityToMaxStudents(capacity),
    curriculum: clean(formData.curriculum),
    prerequisites: clean(formData.prerequisites),
    whatsIncluded: clean(formData.whatsIncluded),
    additionalSupport: clean(formData.additionalSupport),
  };
}
